export default __webpack_public_path__ + "static/sc-customize-activity-types-89312fcf41febd57cce78185170b2999.mp4";